<template lang="pug">
    .associate.col(v-if="job.id_gestor && status.includes(job.status) && perfis.indexOf(user.grupo)")
        Button(layout="gold" @click="modal.show = true")
            i.fa.fa-people-arrows
            | Associar      
        Modal(:modal="modal")
            .row.wp
                .g2.padding.col
                    label Cliente
                    | {{ job.nome_cliente }}
                .g2.padding.col
                    label Forma Atendimento
                    | {{ job.forma_atendimento }}
                .g7.padding.col
                    label Problema
                    | {{ job.problema }}
                .g12.padding.col
                    label Motivo
                    input(v-model="form.motivo_associacao_direta" placeholder="Motivo associação supporter" required)
                .g12.padding.col
                    label Supporter
                    .row.ac
                        input(v-model="s" @keyup.enter="load" placeholder="Nome Supporter")
                        Loader(v-if="loader" layout="mini")
                        i.load.fa.fa-search.pointer(v-else @click="load" title="Pesquisar")
                    .select(v-if="list.length")
                        .op(v-for="t in list" @click="s=t.nome;form.nome_doutor=t.nome;form.id_doutor=t.id;list=[]") {{t.id}} {{t.nome}}
            Button(v-if="form.id_doutor" layout="gold" @click="associate" :loader="loader" style="margin-top: 30px")
                i.fa.fa-people-arrows(v-if="!loader")
                | Associar
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Button from "@/components/Button";
import Modal from "@/components/Modal";
import Loader from "@/components/Loader";
import SelectFilter from "@/components/select/SelectFilter";

export default {
    name: "Associate",
    props: { show: Boolean, job: Object },
    components: { Button, Modal, SelectFilter, Loader },
    data() {
        return {
            status: ['Sem Doutor', 'Categorizado', 'Reagendado', 'Divulgado'],
            perfis: ['Gestor de Demanda', 'Gestor de Registro', 'Gestor de Device', 'Gestor de Infra', 'Gestor de Associação', 'TI', 'Gestor de Operação', 'Diretor de Operação', 'Financeiro'],
            loader: false,
            list: [],
            s: '',
            form: {
                id: this.job.id,
                id_doutor: 0,
                nome_doutor: "",
                motivo_associacao_direta: "",
                tipo_associacao_doutor: "direta"
            },
            modal: {
                title: 'Associar Supporter ao Job ' + this.job.id,
                show: this.show,
            }
        }
    },
    computed: {
        ...mapGetters("user", ["user"]),
    },
    methods: {
        ...mapActions("admin", ["SUPPORTERS_LIST", "ASSOCIATE"]),
        async load() {
            this.loader = true
            let { data } = await this.SUPPORTERS_LIST({ nome: this.s })
            this.list = data || []
            this.loader = false
        },
        async associate() {
            this.loader = true
            let { status } = await this.ASSOCIATE(this.form)
            if (status == 200) {
                this.$emit("update");
                this.modal.show = false
            }
            this.loader = false
        },
    }
};
</script>

<style lang="sass">
@use "@/assets/scss/vars.scss" as *
.associate
    .loader
        margin-left: -30px
    .load
        margin-left: -28px
        font-size: 18px
        &:hover
            color: $purple
            font-size: 22px
    .sfl
        margin-top: -65px
    .modal-box
        padding: 33px
        @media (min-width: $small)
            min-width: 700px
        .content
            padding: 40px
            padding-top: 0
            color: $font-color
            font-size: 15px
            .padding
                padding-right: 12px
            .diary
                .row:first-child
                    margin-top: 50px          
        label
            @include label
            margin-top: 23px
    .controls
        margin-top: 60px
</style>